module.exports = __webpack_public_path__ + "static/media/bglogin.1fc984e9.jpg";